export const AB_API_HOSTS = {
	local_development: 'https://dev-api.aofl.com',
	development: 'https://dev-api.aofl.com',
	staging: 'https://dev-api.aofl.com',
	production: 'https://api.aofl.com'
};

export const DEVICE_KEY_MAP = {
	acquisition_source: 'acquisitionSource',
	device_id: 'deviceId',
	localeCode: 'localeCode',
	is_first_time_visit: 'isFirstTimeVisit',
	app_version: 'appVersion',
	country_code: 'viewerCountry',
	is_mobile_viewer: 'isMobileViewer',
	is_desktop_viewer: 'isDesktopViewer',
	is_webview: 'inApp',
	app_store: 'appStore',
	browser_platform: 'browserPlatform',
	// is_ios_viewer: 'isIosViewer',
	is_link_from_app: 'isLinkFromApp',
	is_aofl_product_uuid: 'isEmailLinkClick',
	is_link_from_email: 'isLinkFromEmail',
	is_automated_testing: 'isAutomatedTesting'
};

export const ACTIVE_EXPERIMENTS = {
	ABCM2_REBRAND: {
		experimentKey: 'abcm-2-rebrand-web-1',
		variants: {
			test: 'test_variant',
			control: 'control_variant'
		}
	},
	ABCM2_REBRAND_SAFARI: {
		experimentKey: 'abcm-2-rebrand-web-1-safari',
		variants: {
			test: 'test_variant',
			control: 'default'
		}
	},
	ABCM2_PERSONALIZED_CANCEL: {
		experimentKey: 'abcm2-personalized-cancel',
		variants: {
			test: 'Test',
			control: 'Control'
		}
	},
	ABCM2_ROKT: {
		experimentKey: 'rokt-2-vs-1',
		variants: {
			test: 'test',
			control: 'default'
		}
	}
};

export const PROFILE = 'abcmouse';

export const EXPERIMENT_KEYS = [
	ACTIVE_EXPERIMENTS.ABCM2_REBRAND.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_REBRAND_SAFARI.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_PERSONALIZED_CANCEL.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_ROKT.experimentKey
];

export const DATA_TYPES = {
	DEVICE: 'device',
	USER: 'user',
	SESSION: 'session',
	MASTER: 'master'
};
